import {enableProdMode, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';

import {environment} from './environments/environment';
import {bootstrapApplication, BrowserModule, Title} from '@angular/platform-browser';
import {EnvironmentsService} from '@services/environments.service';
import {AppRoutingModule} from '@app/app-routing.module';
import {LoginModule} from '@app/login/login.module';
import {PublicModule} from '@app/public/public.module';
import {SharedImports} from '@shared/shared-imports';
import {BrowserAnimationsModule, provideAnimations} from '@angular/platform-browser/animations';
import {DrawerModule} from 'primeng/drawer';
import {AppComponent} from '@app/app.component';
import {MessageService} from 'primeng/api';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import {MyPreset} from './mypreset';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(), importProvidersFrom(BrowserModule, AppRoutingModule, LoginModule, PublicModule, SharedImports, DrawerModule, BrowserAnimationsModule),
    Title,
    EnvironmentsService,
    MessageService,
    provideAnimations(),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          prefix: 'p',
          darkModeSelector: false,
          cssLayer: true,
        },
      },
    })
  ]
})
  .catch(err => console.error(err));

